<template>
  <v-layout pl-4 pr-4 mt-5 mt-0 column v-if="processFlowIndex === 0">
    <v-layout row wrap>
      <v-flex lg4 class="mr-5">
        <v-card>
          <v-card-title>
            <h4>Staff</h4>
          </v-card-title>
          <v-layout class="pl-3 pr-3" column>
            <div class="pb-3">
              Last Sync: {{ $cookies.get("staff_sync") || "" }}
            </div>
            <v-label>★ use separate csv file for bulk update </v-label>
            <input
              v-show="false"
              type="file"
              id="file-input"
              ref="attachedFileStaff"
              :accept="format"
              @change="previewStaffFiles()"
            />
          </v-layout>
          <v-divider class="mt-3"></v-divider>
          <v-card-actions>
            <v-btn flat @click="location.reload()">Reset</v-btn>
            <v-spacer></v-spacer>
            <v-progress-circular
              :size="25"
              color="primary"
              indeterminate
              v-if="loadingStaff"
            ></v-progress-circular>
            <v-icon class="mr-2" color="blue" @click="attachStaff()">
              attach_file
            </v-icon>
            <v-icon class="mr-2" color="orange" @click="upload('staff')">
              cloud_upload
            </v-icon>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex lg4>
        <v-card>
          <v-card-title>
            <h4>Student</h4>
          </v-card-title>
          <v-layout class="pl-3" column>
            <div class="pb-3">
              Last Sync: {{ $cookies.get("student_sync") || "" }}
            </div>
            <v-label>★ use separate csv file for bulk update </v-label>
            <input
              v-show="false"
              type="file"
              id="file-input"
              ref="attachedFileStudent"
              :accept="format"
              @change="previewStudentFiles()"
            />
          </v-layout>
          <v-divider class="mt-3"></v-divider>
          <v-card-actions>
            <v-btn flat @click="location.reload()">Reset</v-btn>
            <v-spacer></v-spacer>
            <v-progress-circular
              :size="25"
              color="primary"
              indeterminate
              v-if="loadingStudent"
            ></v-progress-circular>
            <v-icon class="mr-2" color="blue" @click="attachStudent()">
              attach_file
            </v-icon>
            <v-icon class="mr-2" color="orange" @click="upload('student')">
              cloud_upload
            </v-icon>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import APIBulk from "@/mixins/APIBulk";
export default {
  mixins: [APIBulk],
  data() {
    return {
      format: "text/csv",
      selectedCategory: "",
      processFlowIndex: 0,
      activeUser: {},
      currentCategory: "",
      formData: null,
      loadingStaff: false,
      loadingStudent: false,
      bulk: {},
      csvPaths: {
        staff: "",
        student: ""
      }
    };
  },
  mounted() {
    this.setLastSyncDates();
  },
  methods: {
    attachStaff() {
      this.$refs.attachedFileStaff.click();
    },
    attachStudent() {
      this.$refs.attachedFileStudent.click();
    },
    previewStaffFiles() {
      let files = this.$refs.attachedFileStaff.files;
      this.uploadStaffCSVToServer(files[0]);
    },
    previewStudentFiles() {
      let files = this.$refs.attachedFileStudent.files;
      this.uploadStudentCSVToServer(files[0]);
    },
    uploadStudentCSVToServer: async function(file) {
      // type:csv-student, format:2, path:bulk, image:ST_6221.csv
      this.formData = await new FormData();
      await this.formData.append("type", "csv-student");
      await this.formData.append("format", 2);
      await this.formData.append("path", "bulk");
      await this.formData.append("image", file);
    },
    uploadStaffCSVToServer: async function(file) {
      // type:csv-staff, format:2,  path:bulk, SF_6221.csv
      this.formData = await new FormData();
      await this.formData.append("type", "csv-staff");
      await this.formData.append("format", 2);
      await this.formData.append("path", "bulk");
      await this.formData.append("image", file);
    },
    setLastSyncDates: function() {},
    upload: async function(obj) {
      try {
        let datetime =
          new Date().toLocaleDateString() +
          " " +
          new Date().toLocaleTimeString();
        if (obj === "student") {
          this.loadingStudent = true;
          await this.postCompanyToStudentCSVBulk(this.formData);
          this.$cookies.set("student_sync", datetime, -1);
          this.$toast.success(
            "Student details uploaded successfully",
            "Success",
            {
              position: "topCenter"
            }
          );
        } else {
          this.loadingStaff = true;
          await this.postCompanyToStaffCSVBulk(this.formData);
          this.$cookies.set("staff_sync", datetime, -1);
          this.$toast.success(
            "Staff details uploaded successfully",
            "Success",
            {
              position: "topCenter"
            }
          );
        }
        this.loadingStaff = false;
        this.loadingStudent = false;
        this.setLastSyncDates();
      } catch (error) {
        this.loadingStudent = false;
        this.loadingStaff = false;
        this.$toast.error("Failed to sync bulk", "Error", {
          position: "topCenter"
        });
      }
    }
  }
};
</script>

<style></style>
